module.exports = __webpack_public_path__ + "static/img/ryzs3ab.c94ae945.png";